module.exports = "<div class=\"siteNotAvailable\" >\n\t<img src=\"/assets/images/site_not_available_placeholder.svg\">\n\t<p>Sorry, we're down for maintenance.</p>\n\t<button class=\"btn btn-primary\" (click)=\"reloadPage()\">\n    Try again\n  </button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/site/site-not-available.component.html
// module id = 572
// module chunks = 9